export default "__VITE_ASSET__B05M8LwR__"